import { useEffect, useMemo } from 'react';

import listingLibPerformanceTracking, {
  MEASURE_MARK_NAMES,
} from 'framework-listing-lib/internal/utils/performanceTracking';

import useCrmObjectTypeTracking from './useCrmObjectTypeTracking';

export function useSyncPerformanceTracking() {
  'use memo';
  const { trackPerformanceInteraction } = useCrmObjectTypeTracking();

  useEffect(() => {
    trackPerformanceInteraction();
    // Intentionally no dependency array, trackPerformanceInteraction handles deduplication internally
  });
}

export default function usePerformanceTracking(
  metricName: (typeof MEASURE_MARK_NAMES)[keyof typeof MEASURE_MARK_NAMES]
) {
  'use memo';
  const performanceTracking = useMemo(
    () => listingLibPerformanceTracking.getPerformanceTracking(metricName),
    [metricName]
  );

  performanceTracking.markTimeStart();

  return performanceTracking;
}
